import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

export { default as onAttachmentCreated } from './actions/onAttachmentCreated';
export { default as onAttachmentDeleted } from './actions/onAttachmentDeleted';
export { default as AttachmentWellViewState } from './schema/AttachmentWellViewState';
export {
    default as ConversationAttachmentWellViewState,
} from './schema/ConversationAttachmentWellViewState';
export {
    default as AttachmentPreviewMethod,
} from 'owa-attachment-data/lib/schema/AttachmentPreviewMethod';
export { default as AttachmentViewState } from 'owa-attachment-data/lib/schema/AttachmentViewState';
export { default as ImageLoadState } from 'owa-attachment-data/lib/schema/ImageLoadState';
export {
    default as AttachmentFullViewState,
} from 'owa-attachment-full-data/lib/schema/AttachmentFullViewState';
export {
    default as AttachmentFullViewStrategy,
} from 'owa-attachment-full-data/lib/schema/AttachmentFullViewStrategy';
export {
    default as AttachmentMenuAction,
} from 'owa-attachment-full-data/lib/schema/AttachmentMenuAction';
export { default as AttachmentState } from 'owa-attachment-full-data/lib/schema/AttachmentState';
export {
    default as AttachmentStateType,
} from 'owa-attachment-full-data/lib/schema/AttachmentStateType';
export {
    default as InlineAttachmentState,
} from 'owa-attachment-full-data/lib/schema/InlineAttachmentState';
export {
    default as InlineAttachmentStatus,
} from 'owa-attachment-full-data/lib/schema/InlineAttachmentStatus';
export { AttachmentModelPropertyValues } from 'owa-attachment-model-store';
export { ClientAttachmentId, ClientItemId, MailboxInfo } from 'owa-client-ids';
export { InfoBarMessageViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
export {
    default as AttachmentDataProviderItem,
} from 'owa-service/lib/contract/AttachmentDataProviderItem';
export {
    default as AttachmentDataProviderItemType,
} from 'owa-service/lib/contract/AttachmentDataProviderItemType';
export { default as AttachmentId } from 'owa-service/lib/contract/AttachmentId';
export { default as AttachmentType } from 'owa-service/lib/contract/AttachmentType';
export { default as ItemId } from 'owa-service/lib/contract/ItemId';
export { default as WacAttachmentType } from 'owa-service/lib/contract/WacAttachmentType';
export {
    CreateAttachmentsProperties,
    ShareAttachmentProperties,
    ShouldShareAttachment,
} from './types/CreateAttachmentsProperties';
export {
    CreateAttachmentDependencies,
    CreateAttachmentProcessResult,
} from './actions/createAttachment';
export {
    AttachmentFile,
    AttachmentFileList,
    CloudFile,
    CloudFileList,
} from 'owa-attachment-file-types';
export {
    OnAttachmentCreatedCallback,
    OnAttachmentCanceledOrFailedCallback,
} from './types/AttachmentUploadQueueItem';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "Attachments", webpackPrefetch: true */ './lazyIndex')
);

// Delayed Loaded Actions
export const lazyInitializeAttachments = new LazyAction(lazyModule, m => m.initializeAttachments);

export const lazyReinitializeAttachments = new LazyAction(
    lazyModule,
    m => m.reinitializeAttachments
);

export const lazySetInlineAttachmentStatus = new LazyAction(
    lazyModule,
    m => m.setInlineAttachmentStatus
);

export const lazyAddAttachmentIntoWellBeforeUpload = new LazyAction(
    lazyModule,
    m => m.addAttachmentIntoWellBeforeUpload
);

export const lazyRefreshSharingTipsAttachmentWell = new LazyImport(
    lazyModule,
    m => m.refreshSharingTipsAttachmentWell
);

// Delay Loaded utils
export const lazyCreateAttachmentsViaQueueManager = new LazyImport(
    lazyModule,
    m => m.createAttachmentsViaQueueManager
);

export const lazyDeleteAttachmentsViaQueueManager = new LazyAction(
    lazyModule,
    m => m.deleteAttachmentViaQueueManager
);

export const lazyCreateAttachmentFullViewStateAndStoreBackingModel = new LazyImport(
    lazyModule,
    m => m.createAttachmentFullViewStateAndStoreBackingModel
);

export const lazyCreateAttachmentViewState = new LazyImport(
    lazyModule,
    m => m.createAttachmentFullViewState
);

export const lazyGetAttachmentWellInitialValue = new LazyImport(
    lazyModule,
    m => m.getAttachmentWellInitialValue
);

export const lazyGetAttachmentWellForCompose = new LazyImport(
    lazyModule,
    m => m.getAttachmentWellForCompose
);

export const lazyGetConversationAttachmentWellInitialValue = new LazyImport(
    lazyModule,
    m => m.getConversationAttachmentWellInitialValue
);

export const lazyGetImageDimensionsFromFile = new LazyImport(
    lazyModule,
    m => m.getImageDimensionsFromFile
);

export const lazyGetMaxClassicAttachmentsSize = new LazyImport(
    lazyModule,
    m => m.getMaxClassicAttachmentsSize
);

export const lazyGetAvailableLocalAttachmentSize = new LazyImport(
    lazyModule,
    m => m.getAvailableLocalAttachmentSize
);

export const lazyCreateAttachmentFileFromExistingMailboxAttachment = new LazyImport(
    lazyModule,
    m => m.createAttachmentFileFromExistingMailboxAttachment
);

export const lazyMergeToConversationAttachmentWell = new LazyAction(
    lazyModule,
    m => m.mergeToConversationAttachmentWell
);

export const lazySortConversationAttachmentWell = new LazyAction(
    lazyModule,
    m => m.sortConversationAttachmentWell
);

export const lazyConvertImageViewAttachmentToInlineAttachment = new LazyAction(
    lazyModule,
    m => m.convertImageViewAttachmentToInlineAttachment
);

export const lazyGetLastCloudyAttachmentsSharingIssueForBlockOnSend = new LazyImport(
    lazyModule,
    m => m.getLastCloudyAttachmentsSharingIssueForBlockOnSend
);

export const lazyGetAllValidAttachments = new LazyImport(lazyModule, m => m.getAllValidAttachments);
